<template>
  <div v-if="crumbs.length" class="breadcrumb_container">
    <div class="container-fluid">
      <span v-for="(crumb, index) in crumbs" :key="index">
        <a :href="crumb.link" v-html="crumb.text"></a>
        <template v-if="index != crumbs.length - 1"> / </template>
      </span>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useGetters, useMutations } from "@/composables";

const { getBreadcrumbDetails, getDynamicBreadcrumb, getCanUpdateBreadcrumb } = useGetters();
const { setCanUpdateBreadcrumb } = useMutations();

const route = useRoute();
const router = useRouter();

// Data
const crumbs = ref([]);

// Methods
const updateDynamicBreadcrumb = (val) => {
  let crumb = [];
  val.forEach((element) => {
    let link;
    if ("route" in element) {
      link = element.route;
    } else if ("routeName" in element) {
      link = router.resolve({ name: element.routeName }).fullPath;
    }
    crumb.push({
      text: element.text,
      link,
    });
  });

  crumbs.value = crumb;
};

// Watchers
watch(route, (to) => {
  var currentBreadcrumbState = getCanUpdateBreadcrumb.value;
  if (currentBreadcrumbState == true) {
    setCanUpdateBreadcrumb(false);
    return;
  }
  let val = getDynamicBreadcrumb.value;
  if (!Array.isArray(val) || !val.length) {
    if (!("breadcrumb" in to.meta)) {
      crumbs.value = [];
      return;
    }

    let crumb = [];
    to.meta.breadcrumb.forEach((element) => {
      let link;
      if ("route" in element) {
        link = element.route;
      } else if ("routeName" in element) {
        if (element.routeName === "Checkout" && to.name === "Checkout") {
          link = to.fullPath;
        } else {
          link = router.resolve({ name: element.routeName }).fullPath;
        }
      }
      crumb.push({
        text: element.text,
        link,
      });
    });
    crumbs.value = crumb;
  } else {
    updateDynamicBreadcrumb(val);
  }
}, { immediate: true });

watch(getBreadcrumbDetails, (val) => {
  if (val.name) {
    crumbs.value[1].text = val.name;
  }
});

watch(getDynamicBreadcrumb, (val) => {
  updateDynamicBreadcrumb(val);
});
</script>
<style scoped>
.breadcrumb_container {
  padding: var(--padding-10) 0;
}

.breadcrumb_container a {
  color: var(--body-color, #000);
  font-size: var(--font-size-sm, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-decoration: none;
}

.breadcrumb_container a:hover {
  text-decoration: underline;
  text-decoration-thickness: 10%;
  font-weight: 500;
}
</style>